import { Link } from 'react-router-dom';
import { Icon } from '@repo/ui';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-xtnd-light dark:bg-xtnd-dark-900">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="flex justify-center mb-6">
            <Icon name="XTNDLogo" size="xl" />
          </div>
          <h1 className="text-9xl font-bold text-xtnd-dark-300 dark:text-xtnd-dark-700">404</h1>
          <h2 className="text-2xl font-semibold text-xtnd-dark dark:text-xtnd-white mb-4">
            Page Not Found
          </h2>
          <p className="text-xtnd-dark-400 dark:text-xtnd-dark-400 mb-8">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
        </div>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-xtnd-white bg-xtnd-blue hover:bg-xtnd-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-xtnd-blue-500"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
}
